/**
 * AdminLeadsRpcClient — AtomRpc integration for the admin CRM funnel-head
 * lead endpoints (create/list/get/update/convert). A lead is a person with
 * no customer/intake yet. Requires admin authentication via Clerk session
 * token.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { AdminLeadsRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class AdminLeadsRpcClient extends AtomRpc.Tag<AdminLeadsRpcClient>()(
  "AdminLeadsRpcClient",
  {
    group: AdminLeadsRpcs,
    protocol: makeRpcClientLayer(AdminLeadsRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
